// extracted by mini-css-extract-plugin
module.exports = {"header":"field-panel_header__LcE3c","body":"field-panel_body__3kO89"};